const ResumeStepQRIconSVG = ({ className = "" }) => {
  // Finder (position-detection) square used at three corners of a QR code.
  const Finder = ({ x, y }) => (
    <>
      <rect x={x} y={y} width="12" height="12" rx="2" fill="#333333" />
      <rect x={x + 2} y={y + 2} width="8" height="8" rx="1" fill="#ffffff" />
      <rect x={x + 4} y={y + 4} width="4" height="4" rx="0.5" fill="#0C6ED1" />
    </>
  );

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <Finder x={4} y={4} />
      <Finder x={24} y={4} />
      <Finder x={4} y={24} />
      {/* data modules (bottom-right) */}
      <rect x="24" y="24" width="4" height="4" fill="#333333" />
      <rect x="32" y="24" width="4" height="4" fill="#0C6ED1" />
      <rect x="28" y="28" width="4" height="4" fill="#333333" />
      <rect x="24" y="32" width="4" height="4" fill="#0C6ED1" />
      <rect x="32" y="32" width="4" height="4" fill="#333333" />
    </svg>
  );
};

export default ResumeStepQRIconSVG;
